var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"mainWrapper"},[_c('div',{staticClass:"contentWrapper"},[_c('div',{staticClass:"iframe-flex"},[_c('iframe',{class:_vm.previewStyle,attrs:{"src":_vm.templateUrl}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }